<template>
  <div class="team-content">
    <div class="contentCatetory">
      <div class="imgBox">
        <h2>
          <span id=""> 实验教学项目负责人 </span>
        </h2>
        <ul class="imgList clearfix">
          <li class="fl">
            <img
              src="@/assets/picture/1.gif"
              alt="" />
            <div>
              <p class="first">
                <b>陈骁</b>&nbsp;<span title="教授">教授</span>
              </p>
              <div class="teacher-detail clearfix">
                <p title="所在单位：华南农业大学海洋学院">
                  所在单位：华南农业大学海洋学院
                </p>
                <p title="承担任务：负责人项目总体设计">
                  承担任务：负责人项目总体设计
                </p>
                <router-link to="/info?id=7" class="fr">查看介绍</router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="imgBox">
        <h2><span id=""> 教学服务团队 </span></h2>
        <ul class="imgList clearfix">
          <li class="fl" v-for="(item, index) in list" :key="index">
            <img :src="item.img" alt="" />
            <div>
              <p class="first">
                <b>{{ item.name }}</b>&nbsp;<span :title="item.tag">{{ item.tag }}</span>
              </p>
              <p :title="`所在单位：${item.unit}`">
                所在单位：{{ item.unit }}
              </p>
              <p :title="`承担任务：${item.project}`">
                承担任务：{{ item.project }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Team',
  components: {
  },
  data () {
    return {
      list: [
        {
          img: require('@/assets/picture/1.gif'),
          name: '陈骁',
          tag: '教授',
          unit: '华南农业大学海洋学院',
          project: '负责人项目总体设计'
        },
        {
          img: require('@/assets/picture/2.gif'),
          name: '孙际佳',
          tag: '高级实验师',
          unit: '华南农业大学海洋学院',
          project: '教学设计实施'
        },
        {
          img: require('@/assets/picture/3.gif'),
          name: '张晓勇',
          tag: '副教授',
          unit: '华南农业大学海洋学院',
          project: '教学设计实施'
        },
        {
          img: require('@/assets/picture/4.gif'),
          name: '于宗赫',
          tag: '副教授',
          unit: '华南农业大学海洋学院',
          project: '教学设计实施'
        },
        {
          img: require('@/assets/picture/5.gif'),
          name: '何玉慧',
          tag: '实验师',
          unit: '华南农业大学海洋学院',
          project: '教学设计实施'
        }
      ],
      navbarTitle: [
        '首页',
        '网络相关要求', '项目架构及研发技术', '项目特色', '持续建设服务计划', '教学引导视频',
        '项目申报书', '实验教学项目负责人'
      ],
      id: 1
    }
  },
  watch: {
    '$route.query.id' () {
      this.id = this.$route.query.id
    }
  },
  created () {
    this.id = this.$route.query.id
  },
  mounted () {
    this.onScript()
  },
  methods: {
    scroll() {
      if(window.$(window).scrollTop() > 340) {
        window.$('.side-catalog').stop().animate({
          top:'15px'
        },100)
      }else{
        window.$('.side-catalog').stop().animate({
          top:'350px'
        },100)
      }
      window.$('.scrollTopPx').each(function() {
        if((window.$(this).offset().top-25) < window.$(window).scrollTop()){
          var topPx = (this.id-1)*26+5
          window.$('.arrow').stop().animate({
            top:topPx+'px'
          },300)
        }
      })
    },
    onScript () {
      window.$('.side-bar').height(window.$('.catalog-list').height()+30);
      window.$('.bottom-wrap').css('top',window.$('.catalog-list').height()+40);
      var id=location.hash.split('#')[1];
      window.$('a.title-link').eq(id).click();
      window.$(window).scroll(function(){
        this.scroll()
      })
      window.$('.gotop-button').click(function() {
        window.$(window).scrollTop(0)
        window.$('.arrow').css('top','3px')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.imgList {
  li:nth-child(4n) {
    margin-right: 0;
  }
}
</style>